<template>
  <div>
    <v-container class="content-wrapper" fluid id="equipment-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Equipment
          </h2>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <TableEquipment
              :search="search"
              :url-api="'/api/v1/equipment/provider'"
              :search-attributes="['text']"
            ></TableEquipment>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TableEquipment from './TableEquipment.vue';
export default {
  name: 'Equipment',
  components: { TableEquipment },
  data: () => ({
    search: {},
  }),
};
</script>
